document.addEventListener("DOMContentLoaded", function () {
  handleProductColorSwapping();
  handleProductSiblingHover();
  handleLookVideoHover();
  handleLookPlayer();
  handleSearch();

  // handleWishlist();
});

function handleProductColorSwapping() {
  const colorButtons = document.querySelectorAll(
    "[data-product] button[data-color]"
  );

  colorButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      const product_id = button.getAttribute("data-product-id");
      const productElement = document.getElementById(product_id);

      productElement
        .querySelectorAll("button[data-color]")
        .forEach((button) => {
          button.style.outlineColor = null;
        });

      productElement
        .querySelectorAll("[data-product-main], a[data-variant-color]")
        .forEach((element) => {
          element.style.display = "none";
        });

      button.style.outlineColor = "#634e42";

      const color = button.getAttribute("data-color");
      productElement.querySelector(
        `a[data-variant-color="${color}"]`
      ).style.display = "block";
    });
  });
}

// Hovering another colour (a sibling product) on a product card previews its image.
// Delegated, because cards are also loaded later (search, recommendations).
function handleProductSiblingHover() {
  const getImage = (swatch) =>
    swatch.closest("[data-product]")?.querySelector("img.product-image");

  document.addEventListener("mouseover", (event) => {
    const swatch = event.target.closest?.("[data-sibling-image]");
    const image = swatch && getImage(swatch);
    if (!image) {
      return;
    }

    if (image.dataset.originalSrc === undefined) {
      image.dataset.originalSrc = image.getAttribute("src");
      image.dataset.originalSrcset = image.getAttribute("srcset") || "";
    }
    image.removeAttribute("srcset");
    image.src = swatch.dataset.siblingImage;
  });

  document.addEventListener("mouseout", (event) => {
    const swatch = event.target.closest?.("[data-sibling-image]");
    const image = swatch && getImage(swatch);
    if (
      !image ||
      image.dataset.originalSrc === undefined ||
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    image.src = image.dataset.originalSrc;
    if (image.dataset.originalSrcset) {
      image.setAttribute("srcset", image.dataset.originalSrcset);
    }
  });
}

// A Shop the look card with a video plays it without sound, from the start, while the mouse is on the card.
// Touch is skipped: a tap opens the look page, which plays the video anyway.
function handleLookVideoHover() {
  const getCard = (event) => event.target.closest?.("[data-look-video]");

  document.addEventListener("pointerover", (event) => {
    const card = getCard(event);
    if (!card || event.pointerType === "touch" || card.contains(event.relatedTarget)) {
      return;
    }

    const video = card.querySelector("video");
    video.muted = true;
    video.currentTime = 0;
    // the photo stays visible until the video really plays; leaving early rejects the promise
    video
      .play()
      .then(() => video.classList.remove("opacity-0"))
      .catch(() => {});
  });

  document.addEventListener("pointerout", (event) => {
    const card = getCard(event);
    if (!card || card.contains(event.relatedTarget)) {
      return;
    }

    const video = card.querySelector("video");
    video.pause();
    video.classList.add("opacity-0");
  });
}

// The video on a look page plays on its own without sound. The buttons pause it and turn the sound on;
// clicking the video pauses it too. With "reduce motion" on, it waits until someone presses play.
function handleLookPlayer() {
  document.querySelectorAll("[data-look-player]").forEach((player) => {
    const video = player.querySelector("video");
    const pauseButton = player.querySelector("[data-look-pause]");
    const soundButton = player.querySelector("[data-look-sound]");

    const togglePlay = () => (video.paused ? video.play().catch(() => {}) : video.pause());

    // pressed means paused; also follows pauses by the browser, for instance when a phone locks
    const updatePauseButton = () => pauseButton.setAttribute("aria-pressed", String(video.paused));
    video.addEventListener("play", updatePauseButton);
    video.addEventListener("pause", updatePauseButton);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.pause();
    }
    updatePauseButton();

    video.addEventListener("click", togglePlay);
    pauseButton.addEventListener("click", togglePlay);

    soundButton.addEventListener("click", () => {
      video.muted = !video.muted;
      soundButton.setAttribute("aria-pressed", String(!video.muted));
      // turning the sound on also starts a paused video, otherwise nothing seems to happen
      if (!video.muted && video.paused) {
        video.play().catch(() => {});
      }
    });
  });
}

function handleSearch() {
  const inputs = document.querySelectorAll("[data-search] #search");

  const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback(...args);
      }, wait);
    };
  };

  // Shopify's predictive search only looks at title, product_type, variants.title and vendor by
  // default. Tags and SKUs are added so the dropdown finds what the search page finds; the
  // description is left out on purpose, it matches too loosely for a 4-product preview.
  const predictiveSearchFields =
    "title,product_type,variants.title,vendor,tag,variants.sku";

  inputs.forEach((input) => {
    const container = input.parentElement.querySelector(
      "[data-search-container]"
    );

    // The request in flight. It is cancelled as soon as the query changes, otherwise a slow
    // answer for "tr" can arrive after the one for "trui" and replace it.
    let abortController = null;

    function cancelPendingSearch() {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
    }

    async function search(query) {
      cancelPendingSearch();

      if (query === "") {
        container.innerHTML = "";
        return;
      }

      abortController = new AbortController();
      const { signal } = abortController;

      renderResults(query, `
        <svg class="animate-spin h-5 w-5 text-dark mx-auto col-span-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      `);

      const params = new URLSearchParams({
        q: query,
        section_id: "predictive-search",
        "resources[type]": "product",
        "resources[limit]": "4",
        "resources[options][fields]": predictiveSearchFields,
      });

      let html;
      try {
        const response = await fetch(
          `${window.routes.predictive_search_url}?${params}`,
          { signal }
        );
        if (!response.ok) {
          throw new Error(`Predictive search failed with ${response.status}`);
        }
        html = await response.text();
      } catch (error) {
        // An aborted request was replaced by a newer query, which renders its own results
        if (error.name !== "AbortError") {
          container.innerHTML = "";
        }
        return;
      }

      const doc = new DOMParser().parseFromString(html, "text/html");
      const products = doc.getElementById("predictive-search-results");

      if (!products || products.childElementCount === 0) {
        renderResults(
          query,
          `<span class="col-span-full text-sm">Geen resultaten gevonden.</span>`
        );
        return;
      }
      renderResults(query, products.innerHTML);
    }

    function renderResults(query, html) {
      container.innerHTML = `
        <div class="bg-white z-50 relative border shadow-2xl top-2">
          <div class="flex flex-col bg-light/20 relative">
            <div class="w-full border-b border-black p-3 text-sm font-serif relative">
              <span>
                Bekijk alle resultaten voor: <a class="underline" data-search-all></a>
              </span>

              <button class="absolute right-2 top-0 bottom-0 m-auto" type="button" aria-label="Zoekresultaten sluiten" data-search-close>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
              </button>
            </div>

            <div class="p-3 grid grid-cols-2 col-span-2 gap-4">
            ${html}
            </div>

          </div>
        </div>
      `;

      // The query is set as text and URL parameter instead of being written into the HTML above,
      // so characters like < & # in what the customer typed can't break the markup or the link
      const allResultsLink = container.querySelector("[data-search-all]");
      allResultsLink.href = `${window.routes.search_url}?${new URLSearchParams({
        q: query,
        type: "product",
      })}`;
      allResultsLink.textContent = query;

      container
        .querySelector("[data-search-close]")
        .addEventListener("click", () => {
          cancelPendingSearch();
          container.innerHTML = "";
          input.value = "";
        });
    }

    input.addEventListener(
      "input",
      debounce(function (event) {
        search(event.target.value.trim());
      }, 150)
    );
    
    // Handle Enter key to submit the form
    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        const form = input.closest("form");
        if (form && input.value.trim() !== "") {
          form.submit();
        }
      }
    });
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.currentTarget.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function handleWishlist() {
  const wishlistButtons = document.querySelectorAll("[data-wishlist]");

  wishlistButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      console.log("add to wish");
    });
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getRecentlyViewedProducts() {
  var viewedProducts = [];
  var cookie = getCookie("recently_viewed_products");
  if (cookie) {
    viewedProducts = JSON.parse(cookie);
  }
  return viewedProducts;
}

function addRecentlyViewedProduct(productId) {
  var viewedProducts = getRecentlyViewedProducts();
  var index = viewedProducts.indexOf(productId);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productId);
  setCookie("recently_viewed_products", JSON.stringify(viewedProducts), 7);
}
